<template>
  <div class="home-technical-support" ref="homeTechnicalSupport">
    <div class="title-container ">
      <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
        <img loading="lazy" class="home-technical-support-title animate__animated" v-if="offsetTop < 650"
          src="@/assets/img/home/technicalSupportText1.png" alt="">
      </Transition>
    </div>

    <div class="home-technical-support-left" @mouseenter="mouseEvent('enter', 'left')"
      @mouseleave="mouseEvent('leave', 'left')">
      <img loading="lazy" class="home-technical-support-bg" src="@/assets/img/home/technicalSupportImg1.png" alt="">
      <div>
        <img loading="lazy" class="home-technical-support-icon" src="@/assets/img/home/technicalSupportImg4.png" alt="">
        <div ref="leftType" class="type animate__animated ">{{ '现场维护' }}</div>
        <div ref="leftIntroduction" class="introduction animate__animated">{{ '日常维护、问题解决、定期检修' }} </div>
        <div class="mask"></div>
      </div>
    </div>
    <div class="home-technical-support-middle" @mouseenter="mouseEvent('enter', 'middle')"
      @mouseleave="mouseEvent('leave', 'middle')">
      <img loading="lazy" class="home-technical-support-bg" src="@/assets/img/home/technicalSupportImg2.png" alt="">
      <div>
        <img loading="lazy" class="home-technical-support-icon" src="@/assets/img/home/technicalSupportImg5.png" alt="">
        <div ref="middleType" class="type animate__animated">电话支持</div>
        <div ref="middleIntroduction" class="introduction animate__animated"> {{ '提供7*24小时电话技术支持' }}</div>
        <div class="mask"></div>
      </div>
    </div>
    <div class="home-technical-support-right" @mouseenter="mouseEvent('enter', 'right')"
      @mouseleave="mouseEvent('leave', 'right')">
      <img loading="lazy" class="home-technical-support-bg" src="@/assets/img/home/technicalSupportImg3.png" alt="">
      <div>
        <img loading="lazy" class="home-technical-support-icon icon3" src="@/assets/img/home/technicalSupportImg6.png"
          alt="">
        <div ref="rightType" class="type animate__animated">版本更新及维护</div>
        <div ref="rightIntroduction" class="introduction animate__animated">{{ '软件终身维护，新版本免费升级' }} </div>
        <div class="mask"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    mouseEvent(mode, position) {
      if (mode == 'enter') {
        this.$refs[`${position}Type`].classList.add('animate__flipInX')
        this.$refs[`${position}Introduction`].classList.add('animate__flipInX')
      } else {
        this.$refs[`${position}Type`].classList.remove('animate__flipInX')
        this.$refs[`${position}Introduction`].classList.remove('animate__flipInX')
      }

    }
  },
}
</script>

<style lang='scss' scoped>
.home-technical-support {
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-rows: 7.75rem 53.75rem;
  grid-template-columns: repeat(3, 1fr);


  .title-container {
    width: 100%;
    height: 100%;
    background: #0D2E3A;
    grid-column-start: 1;
    grid-column-end: 4;
    display: flex;
    align-items: center;
    justify-content: center;

    .home-technical-support-title {
      width: 61.1875rem;
      height: 6.5625rem;
    }
  }


  .home-technical-support-left,
  .home-technical-support-middle,
  .home-technical-support-right {
    position: relative;
    width: 40rem;
    height: 53.75rem;
    font-family: FZLanTingHei-R-GBK;
    color: #FFFFFF;

    .home-technical-support-bg {
      width: 100%;
      height: 100%;
    }

    .home-technical-support-icon {
      width: 12.5rem;
      height: 12.5rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .icon3 {
      height: 9.625rem;
    }

    .type {
      position: absolute;
      top: calc(50% + 164px);
      width: 100%;
      transform: translateY(-50%);
      font-size: 2rem;
      z-index: 10;
      letter-spacing: 0.625rem;
    }

    .introduction {
      opacity: 0;
      position: absolute;
      top: calc(50% + 140px);
      transform: translateY(-50%);
      z-index: 10;
      width: 100%;
      font-size: 2rem;
    }
  }


  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #00182C;
    opacity: 0;
    transition: all 0.5s;
  }

  &>:hover .mask {
    opacity: 0.7;
  }

  &>:hover .home-technical-support-icon {
    opacity: 0;
  }

  &>:hover .introduction {
    opacity: 1;
  }

  &>:hover .type {
    top: 15.25rem;
    font-size: 2.5rem;
  }

}
</style>